import { Route } from "react-router-dom";
import { ExpandedContentScreen } from "./ExpandedContentScreen";

export const routes = (
  <>
    <Route path="/cms/:sectionId" Component={ExpandedContentScreen} />
  </>
);